import { Component, OnInit, Injector, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DatatableComponent } from '@swimlane/ngx-datatable';
declare var $: any;
import { CentroDeCustoService } from './centroDeCusto.service';
import { LoadingService } from '../../../util/loader.service';

const swal = require('sweetalert');
import { saveAs } from 'file-saver';
const b64toBlob = require('b64-to-blob');

@Component({
    selector: 'app-centrodecusto',
    templateUrl: './centroDeCusto.component.html',
    styleUrls: ['./centroDeCusto.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CentroDeCustoComponent implements OnInit, OnDestroy {
    rows: Object[]
    selected = [];
    timerId: any;

    registroSelecao = [];
    parametroConsulta: string;
    filterState: boolean = true;
    page = {
        limit: 5,
        count: 0,
        offset: 0,
        descricao: "",
        ativo: true,
    };
    mesagensGrid = {
        'emptyMessage': 'Nenhum dado para exibir',
        'totalMessage': 'Total de registros',
        'selectedMessage': 'Selecionado'
    };
    acoesBottoes: boolean = true;
    botoesAtivados = false;

    @ViewChild(DatatableComponent) table: DatatableComponent;

    ngOnDestroy(): void {
    }

    constructor(public service: CentroDeCustoService, public injector: Injector, private route: ActivatedRoute, private router: Router, public loader: LoadingService) {
        this.reloadTable();
    }

    filtro(event) {
        this.page.descricao = this.parametroConsulta;
        clearTimeout(this.timerId);
        this.timerId = setTimeout(() => {this.page.offset = 0; this.reloadTable();}, 1000);
    }

    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        this.page.offset = pageInfo.offset;
        ///this.registroSelecao = [];
        this.reloadTable();
    }

    onFilterChange(eve: any) {
        this.limparSelecionados();
        this.page.ativo = eve;
        this.reloadTable();
    }
    reloadTable() {
        this.loader.show("body");
        this.service.obterTodos(this.page)
            .subscribe((itens) => {
                this.loader.hide("body");
                this.page.count = itens.data.count;
                this.rows = itens.data.rows;

                this.botoesAtivados = true;
            });
    }

    linkNovo() {
        this.router.navigate(['/v1/centrodecusto/novo']);
    }
    linkEdit() {
        if (this.registroSelecao.length > 1) {
            swal('Atenção', 'Selecione apenas um registro.', 'warning');
        } else {
            this.router.navigate(['/v1/centrodecusto/editar/' + this.registroSelecao[0].codigo]);
        }
    }
    linkAssociarUsuario() {
        if (this.registroSelecao.length < 1) {
            swal('Atenção', 'Selecione um ou mais registro.', 'warning');
        } else {
            var ids = [];
            var nomes = [];
            this.registroSelecao.forEach(function (s) {
                ids.push(s.codigo);
                nomes.push(s.nome);
            });

            this.router.navigate(['/v1/centrodecusto/associarusuario/' + this.registroSelecao[0].codigo],
                {
                    queryParams: { codigosCentroDeCusto: ids, nomesCentroDeCusto: nomes },
                    skipLocationChange: true
                });
        }
    }
    ngOnInit() {

    }
    removerRegistro() {
        swal({
            title: 'Atenção',
            text: 'Você deseja alterar o status desse registro?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#1E0136',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            closeOnConfirm: false
        }, () => {
            swal.close();
            var ids = [];
            this.loader.show("body");
            this.registroSelecao.forEach(function (s) {
                ids.push(s.codigo);
            });
            this.service.ativarOuInativar(ids)
                .subscribe(result => {
                    this.loader.hide("body");
                    if (result.success) {
                        this.reloadTable();
                        this.limparSelecionados();
                        swal('Atenção', 'Ação realizada com sucesso.', 'success');
                    }
                });
        });
    }

    onSelect(event) {
        let itens = event.selected;

        let itensSemduplicacao = itens.filter(function (a) {
            return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
        }, Object.create(null));

        let itemSerRemovido = this.pegarDiferenca(itens, itensSemduplicacao);
        try {
            itens = this.removerItem(itensSemduplicacao, itemSerRemovido);
        } catch (error) {
            //ignore, tudo certo
        }
        this.selected = itens;
        event.selected = itens;

        if (event.selected.length > 0) {
            this.registroSelecao = event.selected;
            this.acoesBottoes = false;
        } else {
            this.acoesBottoes = true;
        }
    }

    marcarCheck(codigo) {
        let x = false;
        this.selected.forEach(item => {
            if (item.codigo == codigo) {
                x = true;
            }
        });
        return x;
    }

    removeItemDuplicado(array) {
        array.filter(function (a) {
            return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
        }, Object.create(null))
        return array;
    }

    removerItem(array, item) {
        for (var i = 0; i < array.length; i++) {
            if (array[i].codigo == item[0].codigo) {
                array.splice(i, 1);
            }
        }

        return array;
    }

    pegarDiferenca(r1, r2) {
        let r3 = r1.filter(a => !r2.includes(a));
        return (r3);
    }

    limparSelecionados() {
        this.registroSelecao = [];
        this.selected = [];
        this.acoesBottoes = true;
    }

    exportarExcel() {
        this.loader.show('body');
        this.botoesAtivados = false;
        this.service.obterExcel(this.page).subscribe((result) => {
            if (result.success) {
                const blob = b64toBlob(result.data.fileBase64, result.data.fileType);

                saveAs(blob, result.data.fileName, {
                    type: result.data.fileType
                });
            } else {
                if (result === 'obterExcel') {
                    swal('Atenção', 'Ação não realizada com sucesso.', 'error');
                }
            }
            this.botoesAtivados = true;
            this.loader.hide('body');
        });
    }

    exportarPdf() {
        this.loader.show('body');
        this.botoesAtivados = false;
        this.service.obterPdf(this.page).subscribe((result) => {
            if (result.success) {
                const blob = b64toBlob(result.data.fileBase64, result.data.fileType);

                saveAs(blob, result.data.fileName, {
                    type: result.data.fileType
                });
            } else {
                if (result === 'obterPdf') {
                    swal('Atenção', 'Ação não realizada com sucesso.', 'error');
                }
            }
            this.botoesAtivados = true;
            this.loader.hide('body');
        });
    }
}
